import { Component, OnInit } from '@angular/core';

import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { BcStateListContext } from '@bayclubs/state';

import { OnlineContentViewReportModel, OnlineContentViewType } from '@bayclubs/group-classes-employee-api';
import * as actions from '../../+state/online-content-view-report.actions';
import { OnlineContentViewReportState } from '../../+state/online-content-view-report.state';
import { ReportFilter, ReportModel, ReportType } from '../../models/reports-model';
import { ReportSelectService } from '../../services/report-select.service';

@Component({
    selector: 'app-online-content-view-report',
    templateUrl: './online-content-view-report.component.html',
    styleUrls: ['./online-content-view-report.component.scss'],
    standalone: false
})
export class OnlineContentViewReportComponent implements OnInit {
    reportModel: ReportModel;

    @Select(OnlineContentViewReportState.getReportData) reportData$: Observable<
        BcStateListContext<OnlineContentViewReportModel>
    >;

    constructor(private store: Store, private reportSelectService: ReportSelectService) {}

    ngOnInit(): void {
        this.reportModel = this.reportSelectService.getReport(ReportType.OnlineContentViewReport);
    }

    showReport(filter: ReportFilter) {
        if (filter) {
            this.store.dispatch(
                new actions.LoadOnlineContentViewReportAction({
                    contentType: filter.contentType != null ? filter.contentType : OnlineContentViewType.All,
                    dateFrom: { value: filter.dateFrom.value, date: filter.dateFrom.value },
                    dateTo: { value: filter.dateTo.value, date: filter.dateTo.value },
                })
            );
        }
    }

    generateReportFile(filter: ReportFilter) {
        if (filter) {
            this.store.dispatch(
                new actions.GenerateOnlineContentViewReportAction({
                    contentType: filter.contentType != null ? filter.contentType : OnlineContentViewType.All,
                    dateFrom: { value: filter.dateFrom.value, date: filter.dateFrom.value },
                    dateTo: { value: filter.dateTo.value, date: filter.dateTo.value },
                })
            );
        }
    }
}
